var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,92.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433 830 c-40 -24 -53 -48 -53 -100 0 -34 6 -48 34 -76 28 -28 41 -34 78 -34 50 0 82 18 103 60 26 51 19 88 -24 131 -45 45 -86 51 -138 19z m132 -27 c27 -28 34 -87 15 -124 -13 -24 -61 -49 -96 -49 -40 0 -94 59 -94 103 0 43 31 84 73 95 44 11 72 4 102 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 798 c-47 -47 56 -242 164 -309 31 -19 34 -25 34 -70 l0 -49 -50 0 c-27 0 -50 -4 -50 -10 0 -6 83 -10 229 -10 143 0 232 4 236 10 3 6 -3 10 -13 10 -16 0 -20 9 -24 55 -8 97 -55 135 -188 156 -120 18 -187 65 -237 164 -14 27 -31 53 -37 57 -17 12 -51 9 -64 -4z m54 -6 c5 -4 20 -27 32 -50 13 -24 35 -59 50 -78 31 -40 132 -94 173 -94 56 0 127 -22 159 -49 30 -25 34 -34 38 -89 l4 -62 -36 0 c-32 0 -36 3 -36 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25 l0 -25 -100 0 -100 0 0 53 c0 47 -3 55 -24 65 -69 31 -162 150 -186 238 -12 43 -12 48 5 60 21 16 26 17 41 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 303 c-16 -3 -28 -19 -43 -59 -27 -73 -26 -86 3 -75 28 11 285 11 313 0 12 -4 24 -5 27 -3 3 3 -4 32 -15 65 -15 45 -27 63 -45 70 -24 9 -196 10 -240 2z m234 -17 c14 -4 27 -22 36 -50 l15 -44 -81 -4 c-45 -1 -119 -2 -165 0 -80 3 -83 4 -76 25 15 53 30 72 59 77 40 8 184 5 212 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/speech.9d06bd851fcdb8796c39990f69e5972c.svg";
export { ForwardRef as ReactComponent };